module.exports = __webpack_public_path__ + "static/media/Virtualizadores1_AcercaDe_1024.8bbf5f2c.png";